/* @flow */

// often when we upload a file it's saved as an array of objects, like
// property: [{ id: '123', path: '1234', temporary: true }]
// but when it's persisted it's saved as a Cloudinary path
// property: 'production_orders_delivery_notes/1/1.pdf'
// this function should be able to handle both cases
export const unwrapTemporaryFile = fileOrPersistedValue => {
  if (
    typeof fileOrPersistedValue === 'string' ||
    !Array.isArray(fileOrPersistedValue)
  ) {
    return fileOrPersistedValue
  }

  const file = fileOrPersistedValue[0] ?? null

  if (!file) {
    return null
  }

  let path = file.path
  if (file.mime.startsWith('video/')) {
    path = 'video/' + path
  }

  return path
}
